const REDIRECT_KEY = 'redirectUrl'

export const leaveGameToLobby = () => {
  const redirectUrl = window.sessionStorage.getItem(REDIRECT_KEY)

  if (redirectUrl !== 'null' && !!redirectUrl) {
    if (window.self !== window.top) {
      window.parent.location.href = redirectUrl
    }
    else {
      window.location.href = redirectUrl
    }
  }
  else {
    window.opener ? window.close() : window.history.go(-1)
  }
}

export const saveRedirectUrlForLeaveGame = (urlParams: URLSearchParams) => {
  const redirectUrl = urlParams.get(REDIRECT_KEY)
  if (redirectUrl) {
    window.sessionStorage.setItem(REDIRECT_KEY, redirectUrl)
  }
}

export const isDisableLeaveGameButton = (disableLeaveGameBtn: boolean, disableLeaveGameBtnByRedirectUrlNotExisted: boolean) => {
  if (disableLeaveGameBtn) return true
  if (disableLeaveGameBtnByRedirectUrlNotExisted) {
    const url = window.sessionStorage.getItem('redirectUrl')
    return url === 'null' || url === null
  }
  return false
}
